module.exports = __webpack_public_path__ + "media/beep.876ddb52.mp3";